export const statesInNigeria = [
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara",
    "Abuja",
    ""
  ];

  export const product = {
    title: "4 Bedroom Semi-Detached Duplex with B/Q",
    desc: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum,sunt in culpa qui officia deserunt mollit anim id est laborum.",
    location: "Harris Crescent Road, by VGC estate, Lekki, Lagos.",
    price: 75000000,
    images: [
      "https://media.rightmove.co.uk/261k/260987/139586807/260987_Sept11_IMG_03_0000.jpeg",
      "https://media.rightmove.co.uk/261k/260987/139586807/260987_Sept11_IMG_05_0000.jpeg",
      "https://media.rightmove.co.uk/261k/260987/139586807/260987_Sept11_IMG_06_0000.jpeg",
      "https://media.rightmove.co.uk/261k/260987/139586807/260987_Sept11_IMG_00_0000.jpeg",
      "https://media.rightmove.co.uk/261k/260987/139586807/260987_Sept11_IMG_02_0000.jpeg",
      "https://media.rightmove.co.uk/261k/260987/139586807/260987_Sept11_IMG_01_0000.jpeg",
    ],
    stock: 2,
    category: "Island Property",
    features: [
      "4 Bedrooms.",
      "CCTV.",
      "24 Hour Security.",
      "3 Car parking.",
      "Dwarf Fencing.",
      "Smart Automation available for maximum comfort.",
      "All room en-suite apartments including a visitor's toilet in the main lounge (sitting room).",
      "2 Large sitting rooms, one each on the ground and first floors.",
      "Spacious master bedroom with terrace (balcony) furnished with modern wardrobes.",
    ],
  }